import { useEffect } from "react";

const SITE_NAME = "HYPPE AROMA";

const upsertMeta = (selector, attrKey, attrVal, content) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attrKey, attrVal);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  return el;
};

const absUrl = (img) => {
  if (!img) return "";
  if (/^https?:\/\//i.test(img)) return img;
  return window.location.origin + (img.startsWith("/") ? img : `/${img}`);
};

export const Seo = ({ title, description, image, path, type = "website", noindex = false, jsonLd }) => {
  useEffect(() => {
    const url = window.location.origin + (path || window.location.pathname);
    const img = absUrl(image);

    if (title) document.title = title;
    if (description) upsertMeta('meta[name="description"]', "name", "description", description);

    // Indexing directive (public pages index; admin/cart/checkout noindex).
    upsertMeta('meta[name="robots"]', "name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    // Open Graph
    upsertMeta('meta[property="og:site_name"]', "property", "og:site_name", SITE_NAME);
    upsertMeta('meta[property="og:type"]', "property", "og:type", type);
    upsertMeta('meta[property="og:url"]', "property", "og:url", url);
    if (title) upsertMeta('meta[property="og:title"]', "property", "og:title", title);
    if (description) upsertMeta('meta[property="og:description"]', "property", "og:description", description);
    if (img) upsertMeta('meta[property="og:image"]', "property", "og:image", img);

    // Twitter Cards
    upsertMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    if (title) upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    if (description) upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    if (img) upsertMeta('meta[name="twitter:image"]', "name", "twitter:image", img);

    // Self-referencing canonical (single element, reused across SPA nav).
    // noindex pages must NOT assert any canonical.
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (noindex) {
      if (canonical) canonical.remove();
    } else {
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", url);
    }

    let ld = document.head.querySelector('script[data-seo-jsonld="true"]');
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.setAttribute("type", "application/ld+json");
        ld.setAttribute("data-seo-jsonld", "true");
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, image, path, type, noindex, jsonLd]);

  return null;
};
